import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Servicios from "@/pages/servicios/page";
import Nosotros from "@/pages/nosotros/page";
import Operturi from "@/pages/operturi/page";
import Plataformas from "@/pages/plataformas/page";
import Faqs from "@/pages/faqs/page";
import Contacto from "@/pages/contacto/page";
import Terminos from "@/pages/terminos/page";
import Privacidad from "@/pages/privacidad/page";
import LibroReclamaciones from "@/pages/libro-reclamaciones/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicios",
    element: <Servicios />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/operturi",
    element: <Operturi />,
  },
  {
    path: "/plataformas",
    element: <Plataformas />,
  },
  {
    path: "/faqs",
    element: <Faqs />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "/terminos-y-condiciones",
    element: <Terminos />,
  },
  {
    path: "/politica-de-privacidad",
    element: <Privacidad />,
  },
  {
    path: "/libro-de-reclamaciones",
    element: <LibroReclamaciones />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;